import { useCallback, useEffect, useState } from 'react'
import PlainItemsSelectorBox from 'app/common/ui-next/_filter-compilations/plain-items-selector-box'
import { subscibeTo } from 'app/common/data-box-store'
import { sortClasses } from 'app/common/lib/sort'
import { prop } from 'ramda'
import {
  ClassType,
  dayCaresListFilter,
  dayCaresListFilterSelection,
  defaultDayCaresListDataReceiver,
  defaultDayCaresListSelection,
  classTypeFilterSelection,
  orgsFilterSelection,
  schoolYearFilterSelection
} from 'app/dataProviders/filter-items'


type Props = {
  id: string
  pending: boolean
}

const sortByTitle = sortClasses<{ title: string }>('down', prop('title'))

export const DayCaresListFilter = ({ id, pending }: Props) => {
  const [isReadySchoolYear, setReadySchoolYear] = useState<boolean>(false)
  const [isReadyOrgs, setReadyOrgs] = useState<boolean>(false)
  const [filterVisibility, setFilterVisibility] = useState<boolean>(false)

  const handleFilter = useCallback(() => {
    if (isReadySchoolYear && isReadyOrgs && filterVisibility) {
      dayCaresListFilter.resetToDefault()
      dayCaresListFilterSelection.resetToDefault()
      dayCaresListFilter.addDataReceiver(defaultDayCaresListDataReceiver)
      dayCaresListFilter.dataReceive()
      dayCaresListFilter.setStatusReady()
    }
  }, [isReadySchoolYear, isReadyOrgs, filterVisibility])

  const handleOrgsFilter = useCallback((data: string[]) => {
    if (data.length === 1) {
      setReadyOrgs(true)
      return
    }
    dayCaresListFilterSelection.resetToDefault()
    setReadyOrgs(false)
  }, [])

  const handleSchoolYearFilter = useCallback((data: string[]) => {
    if (data.length === 1) {
      setReadySchoolYear(true)
      return
    }
    dayCaresListFilterSelection.resetToDefault()
    setReadySchoolYear(false)
  }, [])

  const handleClassTypeFilter = useCallback((data: ClassType) => {
    if (data.length && data[0] === ClassType.DayCares) {
      setFilterVisibility(true)
      return
    }
    dayCaresListFilterSelection.resetToDefault()
    setFilterVisibility(false)
  }, [])

  useEffect(() => {
    handleFilter()
  }, [isReadyOrgs, isReadySchoolYear, filterVisibility, handleFilter])

  useEffect(() => {
    const orgsUnsubsсribe = subscibeTo<string[]>(orgsFilterSelection.id, handleOrgsFilter)
    const schoolYearUnsubsсribe = subscibeTo<string[]>(schoolYearFilterSelection.id, handleSchoolYearFilter)
    const classTypeUnsubsсribe = subscibeTo<ClassType>(classTypeFilterSelection.id, handleClassTypeFilter)

    return (() => {
      orgsUnsubsсribe()
      schoolYearUnsubsсribe()
      classTypeUnsubsсribe()
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    filterVisibility && isReadyOrgs && isReadySchoolYear
    && <PlainItemsSelectorBox
      id={id}
      label="ГПД"
      header="Выбор групп"
      dataBoxData={dayCaresListFilter}
      dataBoxSelection={dayCaresListFilterSelection}
      pleaseSelectText="Нет данных"
      selectedAllOnEmptySelection
      disabled={pending}
      sortFunc={sortByTitle}
      defaultSelection={defaultDayCaresListSelection}
    />
  )
}
